import React, { useMemo } from "react";
import StyledDiv from "../../../../StyledDiv/StyledDiv";
import { IStyledDivStyles } from "../../../../StyledDiv/StyledDiv";
import AnimatedStarWrapper from "../../../../Decorations/PetitPrince/Star/Variants/AnimatedStarWrapper";

interface IPlanetteYellow1Props {
  styles?: IStyledDivStyles;
}

const generateRandomDuration = () => 1.5 + Math.random() * 2.5; // Entre 1.5 et 4 secondes
const generateRandomDelay = () => Math.random() * 2; // Entre 0 et 2 secondes

const PlanetteYellow1 = ({ styles }: IPlanetteYellow1Props) => {
  const starAnimations = useMemo(() => {
    return [
      { duration: generateRandomDuration(), delay: generateRandomDelay() },
    ];
  }, []);
  return (
    <StyledDiv
      styles={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "8px",
        ...styles,
      }}
      className="planette-yellow1"
    >
      <StyledDiv
        styles={{
          position: "relative",
          display: "inline-block",
          width: "100%",
          height: "100%",
        }}
      >
        <svg
          width="79"
          height="63"
          viewBox="0 0 79 63"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "auto", height: "auto" }}
        >
          <path
            d="M54.1697 5.64112C54.1697 5.64112 63.3497 11.9111 66.2597 17.5011C69.1697 23.1011 71.8497 32.2711 69.6197 38.7611C67.3797 45.2511 61.3397 50.8411 61.3397 50.8411C61.3397 50.8411 49.4797 57.3311 47.2397 58.2311C44.9997 59.1211 30.8697 62.6611 25.8497 60.1111C20.8297 57.5611 15.9097 53.5311 13.6697 50.6211C11.4297 47.7111 8.74967 43.6811 8.06967 38.7611C7.39967 33.8411 5.15967 25.1111 7.16967 20.8611C9.17966 16.6111 12.3197 13.2511 14.5597 10.5711C16.7997 7.89112 23.2897 4.08112 28.2097 2.74112C33.1297 1.40112 40.7397 -1.28888 44.9897 0.721124C49.2397 2.74112 54.1697 5.64112 54.1697 5.64112Z"
            fill="#FFD44D"
          />
          <path
            d="M7.29012 32.6012H6.67011C6.62011 36.8111 7.96011 39.7112 9.17011 42.6012C12.9001 51.5411 16.5001 56.7612 25.8401 60.1112C28.6301 61.1112 33.3401 62.7211 37.7201 61.7812C41.2501 61.0212 44.9801 60.3512 48.1401 59.0712C49.7401 58.2411 51.3401 57.4012 52.9301 56.5712C55.3601 56.8512 57.7901 57.1312 60.2201 57.4012C65.2201 58.3812 71.3301 57.8112 75.8501 57.1912C77.5601 55.1112 79.1401 52.9611 78.1401 49.2711C77.5001 48.8911 77.1901 48.6012 76.2601 48.4412C76.5101 50.4112 76.8301 52.0512 76.6801 54.0712C72.9501 55.1812 61.7701 56.3112 58.3401 53.8612C58.2701 53.7912 58.2001 53.7212 58.1301 53.6512C67.6401 49.1112 74.1801 35.0012 68.7601 21.9712C67.5901 19.1512 66.6101 14.6612 63.3401 14.0512V14.2612C66.2301 17.4812 71.2801 29.5512 69.3801 35.9412C67.9601 40.7212 65.3601 43.9712 62.7101 47.4012C61.1301 49.4412 58.5301 52.2612 55.6201 52.8212C52.7701 53.3712 44.1801 48.8912 42.0701 47.8212C35.7101 44.5912 29.5201 41.9511 23.9401 38.0211C20.9401 35.9111 18.4301 33.1312 15.6001 30.9312C12.9201 28.8512 8.77011 24.7612 8.10011 20.9212C9.05011 19.8712 9.57011 18.5612 9.56011 16.5412C9.21011 16.4712 8.86012 16.4012 8.52012 16.3312C8.06012 17.0412 7.19012 18.4112 6.43011 18.8312V18.6212C4.01012 17.6912 -0.0398865 11.1612 2.26012 7.78115C4.98012 3.79115 12.5301 4.78116 16.4301 6.74116V7.16115C14.6601 8.33115 12.7001 9.86115 12.6801 12.7912C13.3201 12.7912 13.2501 12.9312 13.5101 12.7912C15.6001 12.0212 16.2201 9.43115 17.8901 8.20115C21.3401 5.65115 34.2301 0.321155 41.2301 1.74116C44.4901 2.40116 47.6801 2.64115 50.4001 3.82115C52.2801 4.64115 53.3501 6.27115 55.8201 6.53115L56.0301 6.11115C52.4901 5.04115 50.2801 2.03116 46.0301 0.901155C37.3701 -1.39884 29.4501 1.47115 23.3101 4.03115C21.9201 4.65115 20.5301 5.28115 19.1401 5.91115C16.6901 6.52115 14.7501 4.55115 13.1001 4.03115C7.16011 2.18115 1.39011 4.61115 0.180115 9.45115C-1.39989 15.7612 6.55012 22.3612 8.93011 25.5012C16.2501 35.1412 24.7701 42.7012 35.4001 49.0512C40.0201 51.8112 45.4901 53.3912 50.6201 55.5112V55.9312C48.6101 56.2412 46.9101 57.2511 45.2001 57.8111C42.4101 58.7211 39.5201 59.0912 36.4501 59.6912C31.7401 60.6012 26.6701 59.0312 23.7401 57.8111C13.9401 53.7511 8.35011 45.1412 7.28011 32.5912"
            fill="#373636"
          />
        </svg>
        <svg
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: "auto",
            height: "auto",
            marginTop: "-5px",
            marginLeft: "15px",
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 1,
            transform: "translateY(-170%)",
          }}
        >
          <AnimatedStarWrapper
            as="path"
            d="M16.3595 5.55C16.3595 5.55 8.07953 1.3 5.60953 0.850002C3.14953 0.400002 6.05953 6 6.05953 6L6.72953 11.15L3.14953 19.88L0.689531 24.58L8.75953 19.8L14.5995 27.1C14.5995 27.1 16.4995 17.45 17.0995 18.55C17.6995 19.65 23.7495 17.42 25.7595 16.3C27.7695 15.18 28.7695 13.97 28.7695 13.97L21.4795 9.39L23.2995 6.01L26.4295 3.32L17.2495 5.11"
            fill="#FFD44D"
            $animationDuration={starAnimations[0].duration}
            $animationDelay={starAnimations[0].delay}
          />
          <path
            d="M6.05 1.66999C8.57 1.83999 14.58 4.96999 15.85 6.45999C18.38 5.25999 20.39 4.00999 24.19 3.95999V4.99999C22.66 5.57999 20.59 8.06999 20.23 9.78999C23.02 10.71 24.95 12.83 27.11 14.38C27.04 14.45 26.97 14.52 26.9 14.59C24.77 17.23 19.91 16.55 17.1 18.55C15.9 20.53 15.4 23.31 14.39 25.22H13.97C12.23 23.41 10.5 21.61 8.76 19.8C6.4 20.98 4.03 22.16 1.67 23.34V22.92C2.99 21.32 4.73 18.43 5 16.04H4.79V16.25C3.44 17.77 0.4 22.86 0 25C3.6 24.9 5.81 21.71 8.75 20.62C10.69 22.77 12.64 24.93 14.58 27.08H14.79C15.62 24.72 16.46 22.35 17.29 19.99C19.41 19.34 28.6 16.02 28.75 13.95C26.2 12.6 24.37 10.6 21.46 9.36999C21.53 9.29999 21.6 9.22999 21.67 9.15999C22.69 6.24999 25.84 4.48999 27.51 2.06999H26.88C25.81 2.80999 16.03 5.35999 15 4.98999C11.43 3.69999 9.26 0.41999 4.79 -0.0100098V0.40999C4.01 1.77999 5.81 11.19 6.46 12.08V11.87C7.57 10.12 6.1 4.42999 6.04 1.65999"
            fill="#373636"
          />
          <path
            d="M5.20996 15.63C5.13996 15.77 5.06996 15.91 4.99996 16.05H5.20996V15.63Z"
            fill="#373636"
          />
        </svg>
      </StyledDiv>
    </StyledDiv>
  );
};

export default PlanetteYellow1;
